/* eslint-disable react/jsx-filename-extension */
import React from "react";
import Button from "elements/Button";
import Discuss from "parts/Discuss";
import BenefitsSection from "components/BenefitsSection";

export default function ManagedITServices() {
  return (
    <>
      {/* WHAT'S INCLUDED SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            What’s Included
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            Everything your business needs to stay secure, supported and productive.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                24/7 Monitoring
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Real-time monitoring of all systems to prevent downtime before it happens.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Helpdesk & On-Site Support
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Canadian IT experts ready to help your staff anytime problems arise.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Proactive Maintenance
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Patching, updates, optimizations and routine health checks.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <BenefitsSection
        title="Why Choose Managed IT?"
        subtitle="Built to keep your business stable, secure, and productive."
        benefits={[
          {
            id: "pricing",
            title: "Predictable Monthly Pricing",
            text: "No surprise bills — one flat rate for complete IT coverage.",
            delay: 0,
          },
          {
            id: "uptime",
            title: "Less Downtime",
            text: "Preventive monitoring and fast issue resolution keep you running.",
            delay: 120,
          },
          {
            id: "security",
            title: "Stronger Security",
            text: "Threat detection, updates, antivirus, and compliance built in.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "speed", text: "Faster issue resolution" },
          { id: "productivity", text: "Better staff productivity" },
          { id: "security-posture", text: "Improved security posture" },
          { id: "overhead", text: "Reduced internal IT overhead" },
        ]}
      />

      {/* CTA */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Ready for better IT?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let our team handle your technology so you can focus on growth.
            </p>
          </div>

          <Button
            href="/book-consultation"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
